import * as TYPES from "./types";
import db from 'localforage';
import {setRefresh} from "../common/actions";
import {STOPOVER_LEG} from "./default-state";
import httpClient from 'axios';
import {APP_CONFIGS} from "../../config/configs";
import moment from "moment";
// import {AVAILABILITY_MOCK} from "./stopover-mock";

const STOPOVER_MAX_NUMBER_OF_NIGHTS = 7;
const STOPOVER_COMPLETE_NIGHTS_ARRAY = [1, 2, 3, 4, 5, 6, 7];

const calculateDatePlusNumberOfNightsFormatted = (date, numberOfNights) => {
    if (!numberOfNights) numberOfNights = 0;
    return Boolean(date) ? date.clone().add(numberOfNights, 'days').format('D MMMM') : null;
}

export function setCacheValues() {
    return dispatch => {
        dispatch(setRefresh(true));
        db.getItem('IMAGINE_MODE')
            .then(imagineMode => {
                // dispatch(setImagineMode(imagineMode));
            })
            .catch(e => {
                console.log(e.message);
            })
            .finally(() => {
                dispatch(setRefresh(false));
            });
    }
}

export function setPassengerTypeWasChanged(passengerTypeWasChanged) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SET_PAX_TYPE_WAS_CHANGED, passengerTypeWasChanged: passengerTypeWasChanged});
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve(passengerTypeWasChanged);
    };
}

export function setImagineMode(imagineMode) {
    return (dispatch, getState) => {
        /*const {flightCourse} = getState();
        const {legs} = flightCourse;
        const [mainLeg] = legs;
        if (imagineMode) {
            if (mainLeg.origin && mainLeg.origin.airlineOperated) {
                mainLeg.origin = null;
                mainLeg.destination = null;
            }

            if (mainLeg.destination && mainLeg.destination.airlineOperated) {
                mainLeg.destination = null;
            }

            updateCourse(mainLeg);
        }*/
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SET_IMAGINE_MODE, imagineMode: imagineMode});
        db.setItem('IMAGINE_MODE', imagineMode).catch(e => console.log(e.message));
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve(imagineMode);
    }
}

export function setRoundTrip(roundTrip) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SET_ROUND_TRIP, roundTrip: roundTrip});
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve(roundTrip);
    };
}

export function setPassengers(adults = 1, children = 0, infants = 0) {
    return dispatch => {
        dispatch(setRefresh(true));
        if (infants <= adults && children <= 8 - adults && adults <= 8 - children) {
            dispatch({type: TYPES.SET_PASSENGERS, adults: adults, children: children, infants: infants});
            dispatch(setRefresh(false));
            return Promise.resolve({adults: adults, children: children, infants: infants});
        }

        return Promise.reject('Check the pax condition: Adults <= 8 - Children | Children <= 8 - Adults | Infants <= Adults');
    };
}

export function setPassengerType(type) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SET_PASSENGER_TYPE, passengerType: type});
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve(type);
    };
}

export function setPromoCode(code) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SET_PROMO_CODE, promoCode: code});
        dispatch(setRefresh(false));
        return Promise.resolve(code);
    };
}

export function addCourse(course = null) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.ADD_COURSE, course});
        dispatch(setRefresh(false));
        return Promise.resolve(course);
    };
}

export function removeCourse(course) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.REMOVE_COURSE, course});
        dispatch(setRefresh(false));
        return Promise.resolve(course);
    };
}

export function updateCourse(course) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.UPDATE_COURSE, course});
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve(course);
    };
}

export function switchCoursesIndexes(idxA, idxB) {
    return dispatch => {
        dispatch(setRefresh(true));
        dispatch({type: TYPES.SWITCH_COURSES_INDEXES, idxA, idxB});
        dispatch(setRefresh(false));
        dispatch(checkStopoverEligibility());
        return Promise.resolve({idxA, idxB});
    };
}

export function setStopoverOutgoing(outgoing) {
    return dispatch => {
        dispatch({type: TYPES.SET_STOPOVER_OUTGOING, outgoing});
        return Promise.resolve({outgoing});
    };
}

export function setStopoverIncoming(incoming) {
    return dispatch => {
        dispatch({type: TYPES.SET_STOPOVER_INCOMING, incoming});
        return Promise.resolve({incoming});
    };
}

export function setStopoverEligible(eligible) {
    return dispatch => {
        dispatch({type: TYPES.SET_STOPOVER_ELIGIBLE, eligible});
    }
}

export function setStopoverEligibleCityPairs(eligibleCityPairs) {
    return dispatch => {
        return dispatch({type: TYPES.SET_STOPOVER_ELIGIBLE_CITY_PAIRS, eligibleCityPairs});
    }
}

export function setStopoverAvailabilityLoaded(availabilityLoaded) {
    return dispatch => {
        dispatch({type: TYPES.SET_STOPOVER_AVAILABILITY_LOADED, availabilityLoaded});
    }
}

export function resetStopover() {
    return dispatch => {
        return Promise.all([
            dispatch(resetStopoverOutgoing()),
            dispatch(resetStopoverIncoming())
        ])
    }
}

export function resetStopoverOutgoing() {
    return dispatch => {
        return dispatch(setStopoverOutgoing({...STOPOVER_LEG}));
    }
}

export function resetStopoverIncoming() {
    return dispatch => {
        return dispatch(setStopoverIncoming({...STOPOVER_LEG}));
    }
}

export function retrieveStopoverEligibleCityPairs() {
    return dispatch => {
        return httpClient.get(`${APP_CONFIGS.API_ENDPOINT}/sata-stopover/eligible-city-pairs`)
            .then(({data}) => {
                dispatch(setStopoverEligibleCityPairs(data));
            })
            .catch(e => {
                console.error(e.message);
                dispatch(setStopoverEligibleCityPairs([]));
            });
    };
}

export function getCityPairStopoverEligible() {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {stopover, legs} = flightCourse;
        const {eligibleCityPairs} = stopover;
        const [mainLeg] = legs;
        const {origin, destination} = mainLeg;
        if (!origin || !destination) return null;

        return eligibleCityPairs.find(cityPair => cityPair.origin === origin.code && cityPair.destination === destination.code);
    };
}

export function isCityPairStopoverEligible() {
    return dispatch => Boolean(dispatch(getCityPairStopoverEligible()));
}

export function checkStopoverEligibility() {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {roundTrip, imagineMode, passengerType, legs} = flightCourse;
        const [mainLeg] = legs;

        const isStopoverEligible = dispatch(isCityPairStopoverEligible())
            && !imagineMode
            && passengerType === 'ADULT'
            && Boolean(mainLeg.dateStart)
            && Boolean(mainLeg.dateEnd)
            && ((roundTrip === 'RETURN') || (roundTrip === 'ONEWAY'));

        if (isStopoverEligible) {
            dispatch(setStopoverEligible(true));
            dispatch(provideStopover());
        } else {
            dispatch(setStopoverEligible(false));
        }

        return Promise.resolve(isStopoverEligible);
    };
}

export function retrieveStopoverAvailability() {
    return (dispatch, getState) => {
        const {flightCourse: {roundTrip, legs: [mainLeg]}} = getState();
        const isRoundTrip = roundTrip === 'RETURN';
        const {origin, destination, dateStart, dateEnd} = mainLeg;

        const reqBody = {
            origin: origin.code,
            destination: destination.code,
            departureDate: dateStart.format('YYYY-MM-DD'),
        };

        if (isRoundTrip) reqBody.returnDate = dateEnd.format('YYYY-MM-DD');

        dispatch(setStopoverAvailabilityLoaded(false));
        return httpClient.post(`${APP_CONFIGS.API_ENDPOINT}/sata-stopover/available-dates`, reqBody)
            .then(({data}) => {
                return Promise.resolve(data);
            })
            .catch(e => {
                console.error('API Availability:', e.message);
            })
            .finally(() => {
                dispatch(setStopoverAvailabilityLoaded(true));
            });
    };
}

export function parseStopoverAvailability(availability) {
    return (dispatch, getState) => {
        const disabledNights = [1, 2, 3, 4, 5, 6, 7];

        if (!availability) {
            return {
                outbound: {PDL: [], TER: []},
                inbound: {PDL: [], TER: []},
            }
        }

        const {flightCourse: {legs: [mainLeg]}} = getState();
        const {dateStart, dateEnd} = mainLeg;
        const {outbound, inbound} = availability;
        const {dates: outPdlDates = []} = (outbound && outbound.find(stopoverAirport => stopoverAirport.airportIataCode === 'PDL')) || {};
        const {dates: outTerDates = []} = (outbound && outbound.find(stopoverAirport => stopoverAirport.airportIataCode === 'TER')) || {};
        const {dates: inPdlDates = []} = (inbound && inbound.find(stopoverAirport => stopoverAirport.airportIataCode === 'PDL')) || {};
        const {dates: inTerDates = []} = (inbound && inbound.find(stopoverAirport => stopoverAirport.airportIataCode === 'TER')) || {};
        const {outboundShift = 0, inboundShift = 0} = dispatch(getCityPairStopoverEligible());

        return {
            outbound: {
                PDL: [...disabledNights.filter(day => !outPdlDates || !outPdlDates.map(d => moment(d).diff(dateStart.clone().startOf('day'), 'days')).includes(day + outboundShift))],
                TER: [...disabledNights.filter(day => !outTerDates || !outTerDates.map(d => moment(d).diff(dateStart.clone().startOf('day'), 'days')).includes(day + outboundShift))],
            },
            inbound: {
                PDL: [...disabledNights.filter(day => !inPdlDates || !inPdlDates.map(d => moment(d).diff(dateEnd.clone().startOf('day'), 'days')).includes(day + inboundShift))],
                TER: [...disabledNights.filter(day => !inTerDates || !inTerDates.map(d => moment(d).diff(dateEnd.clone().startOf('day'), 'days')).includes(day + inboundShift))],
            }
        };
    };
}

export function provideStopover() {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {roundTrip, stopover, legs} = flightCourse;
        const {outgoing, incoming} = stopover;
        const {selectedAirport: outSelectedAirport, numberOfNights: outNumberOfNights} = outgoing;
        const {selectedAirport: inSelectedAirport, numberOfNights: inNumberOfNights} = incoming;
        const [mainLeg] = legs;
        const {origin, destination, dateStart, dateEnd} = mainLeg;
        const {outboundShift = 0} = dispatch(getCityPairStopoverEligible());
        const isRoundTrip = roundTrip === 'RETURN';

        return dispatch(retrieveStopoverAvailability())
            .then(availability => {
                const {outbound: outboundDisabledNights, inbound: inboundDisabledNights} = dispatch(parseStopoverAvailability(availability));
                const outboundLeg = {
                    ...STOPOVER_LEG,
                    disabledNights: {...outboundDisabledNights},
                    disabledAirports: []
                };
                const inboundLeg = {...STOPOVER_LEG, disabledNights: {...inboundDisabledNights}, disabledAirports: []};

                if (isRoundTrip) {
                    //Check dates interval and add the out of bounds OUTBOUND nights to the disabled nights array.
                    let datesIntervalInDays = dateEnd.diff(dateStart, 'days') - outboundShift;
                    if (datesIntervalInDays < 1) datesIntervalInDays = 1;
                    if (datesIntervalInDays > STOPOVER_MAX_NUMBER_OF_NIGHTS) datesIntervalInDays = STOPOVER_MAX_NUMBER_OF_NIGHTS + 1;
                    for (let i = datesIntervalInDays; i <= STOPOVER_MAX_NUMBER_OF_NIGHTS; i++) {
                        if (!outboundLeg.disabledNights.PDL.includes(i)) outboundLeg.disabledNights.PDL.push(i);
                        if (!outboundLeg.disabledNights.TER.includes(i)) outboundLeg.disabledNights.TER.push(i);
                    }
                }

                //define disabled airports
                if (outboundLeg.disabledNights.PDL.length >= STOPOVER_MAX_NUMBER_OF_NIGHTS || origin.code === 'PDL' || destination.code === 'PDL') outboundLeg.disabledAirports.push('PDL');
                if (outboundLeg.disabledNights.TER.length >= STOPOVER_MAX_NUMBER_OF_NIGHTS || origin.code === 'TER' || destination.code === 'TER') outboundLeg.disabledAirports.push('TER');
                if (inboundLeg.disabledNights.PDL.length >= STOPOVER_MAX_NUMBER_OF_NIGHTS || origin.code === 'PDL' || destination.code === 'PDL') inboundLeg.disabledAirports.push('PDL');
                if (inboundLeg.disabledNights.TER.length >= STOPOVER_MAX_NUMBER_OF_NIGHTS || origin.code === 'TER' || destination.code === 'TER') inboundLeg.disabledAirports.push('TER');

                dispatch(setStopoverOutgoing({...outboundLeg}));
                dispatch(setStopoverIncoming({...inboundLeg}));

                //reuse logic to select OUTGOING airports and number of nights
                if (outSelectedAirport) {
                    if (!outboundLeg.disabledNights[outSelectedAirport].includes(outNumberOfNights)) {
                        dispatch(selectStopoverOutgoingAirport(outSelectedAirport));
                        dispatch(setOutgoingNumberOfNights(outNumberOfNights, false));
                    } else {
                        dispatch(setStopoverOutgoing({message: 'There are no flights available for the chosen date. Please check the selected number of nights.'}));
                    }
                }

                //reuse logic to select INCOMING airports and number of nights
                if (inSelectedAirport && isRoundTrip) {
                    if (!inboundLeg.disabledNights[inSelectedAirport].includes(inNumberOfNights)) {
                        dispatch(selectStopoverIncomingAirport(inSelectedAirport));
                        dispatch(setIncomingNumberOfNights(inNumberOfNights, false));
                    } else {
                        dispatch(setStopoverIncoming({message: 'There are no flights available for the chosen date. Please check the selected number of nights.'}));
                    }
                }

                return Promise.resolve({availability});
            });
    }
}

export function selectStopoverOutgoingAirport(stopoverAirport) {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {stopover} = flightCourse;
        const {outgoing} = stopover;
        const {selectedAirport, disabledNights} = outgoing;

        if (selectedAirport === stopoverAirport) {
            const stopoverLeg = {
                selectedAirport: null,
                numberOfNights: null,
                departureDate: null,
                message: null
            };

            dispatch(setStopoverOutgoing({...stopoverLeg}));
            return Promise.resolve({...stopoverLeg})
        }

        const airportDisabledNights = disabledNights[stopoverAirport];
        const availableNights = STOPOVER_COMPLETE_NIGHTS_ARRAY.filter(n => !airportDisabledNights.includes(n));
        const numberOfNights = availableNights.length ? Math.min(...availableNights) : null;
        const stopoverLeg = {
            selectedAirport: stopoverAirport,
            message: null
        };

        dispatch(setStopoverOutgoing({...stopoverLeg}));
        dispatch(setOutgoingNumberOfNights(numberOfNights));
        return Promise.resolve({...stopoverLeg})
    }
}

export function selectStopoverIncomingAirport(stopoverAirport) {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {stopover} = flightCourse;
        const {incoming} = stopover;
        const {selectedAirport, disabledNights} = incoming;

        if (selectedAirport === stopoverAirport) {
            const stopoverLeg = {
                selectedAirport: null,
                numberOfNights: null,
                departureDate: null,
                message: null,
            };

            dispatch(setStopoverIncoming({...stopoverLeg}));
            return Promise.resolve({...stopoverLeg})
        }

        const airportDisabledNights = disabledNights[stopoverAirport];
        const availableNights = STOPOVER_COMPLETE_NIGHTS_ARRAY.filter(n => !airportDisabledNights.includes(n));
        const numberOfNights = availableNights.length ? Math.min(...availableNights) : null;
        const stopoverLeg = {
            selectedAirport: stopoverAirport,
            message: null,
        };

        dispatch(setStopoverIncoming({...stopoverLeg}));
        dispatch(setIncomingNumberOfNights(numberOfNights));

        return Promise.resolve({...stopoverLeg})
    }
}

export function setOutgoingNumberOfNights(numberOfNights, resetIfSameNumberAsPreviousState = false) {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {stopover, legs} = flightCourse;
        const {outgoing} = stopover;
        const [mainLeg] = legs;
        const {dateStart} = mainLeg;
        const {outboundShift = 0} = dispatch(getCityPairStopoverEligible());
        const nOfNights = numberOfNights;

        let stopoverLeg = {
            numberOfNights: nOfNights,
            departureDate: calculateDatePlusNumberOfNightsFormatted(dateStart, nOfNights + outboundShift),
            message: null,
        };

        if (resetIfSameNumberAsPreviousState && nOfNights === outgoing.numberOfNights) {
            stopoverLeg = {
                selectedAirport: null,
                numberOfNights: null,
                departureDate: null,
                message: null,
            };
        }

        dispatch(setStopoverOutgoing({...stopoverLeg}));
    }
}

export function setIncomingNumberOfNights(numberOfNights, resetIfSameNumberAsPreviousState = false) {
    return (dispatch, getState) => {
        const {flightCourse} = getState();
        const {stopover, legs} = flightCourse;
        const {incoming} = stopover;
        const [mainLeg] = legs;
        const {dateEnd} = mainLeg;
        const {inboundShift = 0} = dispatch(getCityPairStopoverEligible());
        const nOfNights = numberOfNights;

        let stopoverLeg = {
            numberOfNights: nOfNights,
            departureDate: calculateDatePlusNumberOfNightsFormatted(dateEnd, nOfNights + inboundShift),
            message: null,
        };

        if (resetIfSameNumberAsPreviousState && nOfNights === incoming.numberOfNights) {
            stopoverLeg = {
                selectedAirport: null,
                numberOfNights: null,
                departureDate: null,
                message: null,
            };
        }

        dispatch(setStopoverIncoming({...stopoverLeg}));
    }
}


